// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"451":"c438d0f3","1448":"ad740cff","3059":"fd451ce1","4289":"ad740cff","6220":"ad740cff","9960":"c438d0f3"}[chunkId] + ".chunk.css";
};